export default __webpack_public_path__ + "static/media/IncredibleAnimalsHibernators_03.59388d5e.png";